<div class="event-details">
  <div class="header">
    <h1 class="title">{{event.name}}</h1>
    <div class="date">
      <fa-icon [icon]="calendarIcon"></fa-icon>
      <span>{{getFormattedDate()}}</span>
    </div>
    <div class="instructors">
      @for (instructor of event.instructors; track instructor) {
        <div class="instructor">
          <img [src]="instructor.picture" [alt]="instructor.name + ' profile'" class="picture">
          <div>
            <span class="heading">Instructor:</span>
            <p class="name">{{instructor.name}}</p>
          </div>
        </div>
      }
    </div>
    <h2 class="subtitle">You're almost there! Just fill in a few quick details to secure your spot.</h2>
  </div>
  <div class="details">
    <div class="image">
      <img [src]="event.image" alt="{{event.name}} - event image">
      @if (event.attendeesCount > 2) {
        <div class="banner">
          Join {{event.attendeesCount}} fellow authors who already registered
        </div>
      }
    </div>
    @if (event.attendeesCount > 2) {
      <div class="banner mobile">
        Join {{event.attendeesCount}} fellow authors who already registered
      </div>
    }
    <div class="description" [innerHTML]="event.descriptions.full"></div>
  </div>
  <div class="context">
    @if (event.status === 'cancelled') {
      <h3 class="context-title">Event Cancelled</h3>
      <p>This event has been canceled. If you have registered for this event, please check your email for
      instructions.</p>
    } @else {
      @if (mode === 'edit') {
        @if(!isPastDeadline){
          <h3 class="context-title">Update Your Information</h3>
          <div class="ticket">
            <app-event-ticket [event]="event"></app-event-ticket>
          </div>
          <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <app-input-text
              fullWidth id="first_name"
              formControlName="first_name"
              label="First Name"
              [error]="hasErrors('first_name')"
              [showMessages]="hasErrors('first_name')"
              [required]="true">
            </app-input-text>
            <app-input-text
              fullWidth
              id="last_name"
              formControlName="last_name"
              label="Last Name"
              [error]="hasErrors('last_name')"
              [showMessages]="hasErrors('last_name')"
              [required]="true">
            </app-input-text>
            <app-input-text
              fullWidth id="email"
              formControlName="email"
              label="Email"
              [error]="hasErrors('email')"
              [showMessages]="hasErrors('email')"
              [required]="true">
            </app-input-text>
            <app-schema-form-builder [form]="form" formGroupName="additionalQuestions"
            [schemas]="event.questions"></app-schema-form-builder>
            <button class="button regular solid-green">Update</button>
          </form>
        } @else {
          <h3 class="context-title">Registration is Closed</h3>
          <p>We’re sorry, but the registration deadline for this event has passed and tickets are no longer
          available. Please remove this item from your cart.</p>
        }
      }
      @if (mode === 'signup') {
        @if(isEventSoldOut){
          <h3 class="context-title">Event is Sold Out</h3>
          <p>We’re sorry, but this event has been sold out and no more tickets are available.</p>
          <p><a target="_blank" class="newsletter-link"
            href="https://www.writtenwordmedia.com/sign-up/">Subscribe to our
          Newsletter</a> for monthly author-focused events, tools, and updates.</p>
        } @else if(!isPastDeadline){
          <h3 class="context-title">Complete Your Registration</h3>
          <div class="ticket">
            <app-event-ticket [event]="event"></app-event-ticket>
          </div>
          <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <app-input-text
              fullWidth
              id="first_name"
              fullWidth
              id="first_name"
              formControlName="first_name"
              label="First Name"
              [error]="hasErrors('first_name')"
              [showMessages]="hasErrors('first_name')"
              [required]="true">
            </app-input-text>
            <app-input-text
              fullWidth
              id="last_name"
              formControlName="last_name"
              label="Last Name"
              [error]="hasErrors('last_name')"
              [showMessages]="hasErrors('last_name')"
              [required]="true">
            </app-input-text>
            <app-input-text
              fullWidth
              id="email"
              formControlName="email"
              label="Email"
              [error]="hasErrors('email')"
              [showMessages]="hasErrors('email')"
              [required]="true">
            </app-input-text>
            <app-schema-form-builder [form]="form" formGroupName="additionalQuestions"
            [schemas]="event.questions"></app-schema-form-builder>
            <button class="button regular solid-green">Add to Cart</button>
          </form>
        } @else {
          <h3 class="context-title">Registration is Closed</h3>
          <p>We’re sorry, but the registration deadline for this event has passed and tickets are no longer
          available.</p>
          <p><a target="_blank" class="newsletter-link"
            href="https://www.writtenwordmedia.com/sign-up/">Subscribe to our
          Newsletter</a> for monthly author-focused events, tools, and updates.</p>
        }
      }
      @if (mode === 'view'){
        @if (isEventComplete) {
          <h3 class="context-title">Event is Complete</h3>
          @if (attendees.length > 0) {
            <div class="materials-container">
              <p>Thank you for attending.</p>
              @if (event.materials.length) {
                <ul class="materials">
                  @for (material of event.materials; track material) {
                    <li>
                      <a [href]="material.content" target="_blank">{{material.label}}</a>
                    </li>
                  }
                </ul>
              }
            </div>
          } @else {
            <p>
              We’re sorry, but the registration deadline for this event has passed and tickets are no
              longer available.
            </p>
          }
        } @else if (attendees.length > 0) {
          <h3 class="context-title">You Are Registered</h3>
          <div class="attendees">
            @for (attendee of attendees; track attendee) {
              <div class="attendee">
                <div>
                  <div class="name">{{ attendee.firstName }} {{ attendee.lastName }}</div>
                  <div class="ticket-number">Ticket Number: {{attendee.ticketNumber}}</div>
                </div>
                <div class="order-details">
                  <div class="order-id">Ordered on</div>
                  <div class="date">{{ attendee._order.orderCompletedDate | date:'mediumDate' }}</div>
                </div>
              </div>
            }
          </div>
          @if (event.materials.length) {
            <div class="materials-container">
              <p>Review your event materials ahead of time to get the most out of the session:</p>
              <ul class="materials">
                @for (material of event.materials; track material) {
                  <li>
                    <a [href]="material.content" target="_blank">{{material.label}}</a>
                  </li>
                }
              </ul>
            </div>
          }
        } @else {
          <h3 class="context-title">Go to Registration</h3>
          <p>You can still join us, go to <a [routerLink]="['registration']">registration.</a></p>
        }
      }
    }
  </div>
</div>
